import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Tasks from "@/pages/Tasks";
import TaskDetail from "@/pages/TaskDetail";
import Employees from "@/pages/Employees";
import Areas from "@/pages/Areas";
import Compliance from "@/pages/Compliance";
import Notifications from "@/pages/Notifications";
import EmployeeHome from "@/pages/EmployeeHome";
import MyCompliance from "@/pages/MyCompliance";
import Meetings from "@/pages/Meetings";
import { Loader2 } from "lucide-react";

function Splash() {
  return (
    <div className="flex h-screen items-center justify-center bg-slate-50">
      <Loader2 className="h-8 w-8 animate-spin text-slate-400" />
    </div>
  );
}

function Guard({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={user.role === "admin" ? "/dashboard" : "/hoy"} replace />;
  }
  return <Layout>{children}</Layout>;
}

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading || user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/dashboard" : "/hoy"} replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/" element={<RootRedirect />} />

      <Route path="/dashboard" element={<Guard roles={["admin"]}><Dashboard /></Guard>} />
      <Route path="/funcionarios" element={<Guard roles={["admin"]}><Employees /></Guard>} />
      <Route path="/areas" element={<Guard roles={["admin"]}><Areas /></Guard>} />
      <Route path="/cumplimiento" element={<Guard roles={["admin"]}><Compliance /></Guard>} />

      <Route path="/hoy" element={<Guard roles={["empleado"]}><EmployeeHome /></Guard>} />
      <Route path="/mi-cumplimiento" element={<Guard roles={["empleado"]}><MyCompliance /></Guard>} />

      <Route path="/tareas" element={<Guard><Tasks /></Guard>} />
      <Route path="/tareas/:id" element={<Guard><TaskDetail /></Guard>} />
      <Route path="/notificaciones" element={<Guard><Notifications /></Guard>} />
      <Route path="/reuniones" element={<Guard><Meetings /></Guard>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
